export function eventDataLayer(paramsGA4) {
  if (typeof window !== 'undefined' && !!paramsGA4) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(paramsGA4)
  } else {
    console.log('Error: GA Tracciamenti - window.dataLayer not found')
  }
}
